<template>
	<VsSelect :lable="lable"
	:lablewidth="lablewidth" :width="width"
	:classtype="classtype"
	v-model="select.value"
	:loopdata="select.droplist"
	:keys="['UserName','TrueName']"
	@input="fnInputAct"
	@on-enter="fnEnterpressAct"
	@click="fnInputSelect"
	@inputserch="fnInputSelect"
	:requiremore="select.requiremore"
	@require="fnInputSelect"
	@on-confirm="fnSelectConfirm"
	>
	</VsSelect>
</template>

<script>
	export default{
		props:{
			loopdata:{},
			keys:{},
			lablewidth:{},
			width:{},
			lable:{},
			classtype:{},
			selectValue:{},
			returnkey:{}
			
		},
		model: {
			prop: 'selectValue',
			event: 'on-model'
		},
		watch:{
			selectValue(nval){
				//this.select.value=nval
			}
			
		},
		data(){
			return{
				select:{
					value:'',
					PageNo:'1',
					PageSize:'50',
					requiremore:true,
					droplist:[],
					},
			}
		},
		
		activated(){
					let params=this.$fun.GetUserConstant()
					this.$Api.ErpGetMainUsers(params).then((res)=>{
							this.select.droplist = this.select.droplist.concat(res.data)
					})
		},
		mounted(){
					let params=this.$fun.GetUserConstant()
					this.$Api.ErpGetMainUsers(params).then((res)=>{
							this.select.droplist = this.select.droplist.concat(res.data)
					})
		},
		methods:{
			fnInputAct($event){
				this.select.droplist=[]
				this.select.PageNo=1
				this.select.requiremore=true
				this.fnSelectConfirm()
				this.$emit('input',$event)
				if(this.selectValue){this.$emit('on-model',"")}
			},
			fnInputSelect(){
			//	this.droplist=''
				//this.$emit('on-model',"")
				this.select.value=''
				if(this.select.requiremore){
					let params=this.$fun.GetUserConstant()
					// params.Operators='模糊查询'
					// params.PageSize=this.select.PageSize
					// params.PageNo=this.select.PageNo
					// params.Values=this.select.value
					console.log(params)
					this.$Api.ErpGetMainUsers(params).then((res)=>{
						console.log('ressss',res)
						if(res.data.length>0){
                            this.select.droplist = []
							this.select.droplist = this.select.droplist.concat(res.data)
							this.select.PageNo++
						}else{
							this.select.requiremore=false
							this.select.PageNo=1
						}
					})
				}
			},
			fnSelectConfirm(data){
				console.log('returnkey',data)
				if(data){
					if(this.returnkey){
						this.$emit('on-model',data[this.returnkey])
						this.$emit('on-select',data)
					}else{
						this.$emit('on-select',data)
					}
				}else{
					console.log('else')
				}
			},
			fnEnterpressAct($event){
				this.$emit('on-enter',$event)
			}
		}
	}
</script>

<style>
</style>
